export default __webpack_public_path__ + "7e8ae7ab0eef5bba40de4638b1f7f443.svg";